<template>
  <div class="kpt-remote-data-usage">
    <div class="usage-item is-flex is-space-between">
      <label class="label">Satellite</label>
      <p>{{$numeral(satValue).format('0.00 b')}}</p>
    </div>
    <div class="usage-item is-flex is-space-between" v-if="hasCellular">
      <label class="label">Cellular</label>
      <p>{{$numeral(celValue).format('0.00 b')}}</p>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    remote: {
      type: Object,
      required: true
    },
    subscription: {
      type: Object,
      required: true
    }
  },
  computed: {
    satValue() {
      if (!this.remote.satelliteNetwork) return 0;
      const dataUsed = parseFloat(this.remote.satelliteNetwork.dataUsed);
      return dataUsed || 0;
    },
    satMax() {
      return this.subscription.limit;
    },
    celType() {
      return this.percentFilled(this.celValue, this.celMax) < 0.8 ? 'is-success' : 'is-warning';
    },
    celValue() {
      if (!this.remote.cellularNetwork) return 0;
      const dataUsed = parseFloat(this.remote.cellularNetwork.dataUsed);
      return dataUsed || 0;
    },
    hasCellular() {
      return this.subscription.hasCellular;
    }
  },
  methods: {
    percentFilled(value, max) {
      return value / max;
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../styles/colors';

.kpt-remote-data-usage {
  background: $white-ter;
  padding: 12px;

  .usage-item {
    margin-bottom: 12px;

    &:nth-child(2) {
      margin-top: 12px;
    }

    &:last-child {
      margin-bottom: 0;
    }

    .label { 
      margin-bottom: 0;
    }
  }
}
</style>
